// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.k-form-field .StripeElement {
  border: 1px solid rgba(38, 38, 38, 0.3);
  border-radius: 8px;
  color: #54698d;
  height: 38px;
  padding: 4px 8px;
  font-family: 'sofia-pro', sans-serif;
  font-size: 18px;
  line-height: 24px;
}
.k-form-field .StripeElement .__PrivateStripeElement {
  top: 7px;
}
.noticeMessage {
  display: block;
  max-width: 270px;
  margin: 10px auto 0 auto;
  font-size: 12px;
  line-height: 16px;
  color: #262626;
  padding: 0 10px;
  margin-top: -20px;
}
.noticeMessage a {
  font-weight: 700;
  color: #19419b;
}
.fieldset .verifyCardButton {
  margin: 20px auto 0 auto;
  left: 182px;
  width: 108px;
  height: 36px;
  background-color: rgba(25, 65, 155, 0.13);
  border-radius: 19px;
  font-size: 15px;
  line-height: 20px;
  color: #19419b;
}
.fieldset .verifyCardButton span {
  opacity: 1;
}
.fieldset .verifiedResult {
  display: inline-flex;
  justify-content: space-between;
  vertical-align: bottom;
  width: 288px;
  margin: 5px auto;
}
.fieldset .verifiedResult span {
  display: inline-block;
  line-height: 32px;
  color: #1589ee;
  vertical-align: middle;
}
.fieldset .verifiedResult span:first-child {
  text-transform: capitalize;
}
.fieldset .verifiedResult button.deleteIcon {
  margin: 0;
  vertical-align: bottom;
  border-radius: 4px;
  background-color: transparent;
}
.fieldset .verifiedResult button.deleteIcon img {
  width: 20px;
}
.stripeFormErrorMessage {
  margin: 0 auto 20px auto;
  font-size: 12px;
  color: #ff5151;
}
@media (min-width: 786px) {
  .noticeMessage {
    display: inline-block;
    max-width: calc(100% - 120px);
  }
  .fieldset .verifiedResult {
    width: 318px;
  }
  .stripeFormErrorMessage {
    padding-left: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/StripeCreditCardForm.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EAEE,uCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AAWF;AApBA;EAYG,QAAA;AAWH;AANA;EAGC,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAMD;AAhBA;EAYE,gBAAA;EACA,cAAA;AAOF;AAHA;EACC,wBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAKD;AAdA;EAYE,UAAA;AAKF;AADA;EACC,oBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAGD;AARA;EAQE,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAGF;AAdA;EAeE,0BAAA;AAEF;AAjBA;EAmBE,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;AACF;AAvBA;EAwBG,WAAA;AAEH;AAGA;EACC,wBAAA;EACA,eAAA;EACA,cAAA;AADD;AAIA;EACC;IACC,qBAAA;IACA,6BAAA;EAFA;EAKD;IACC,YAAA;EAHA;EAMD;IACC,kBAAA;EAJA;AACF","sourcesContent":["@import '../../constants.less';\n\n.k-form-field {\n\t.StripeElement {\n\t\tborder: @fieldBorder;\n\t\tborder-radius: 8px;\n\t\tcolor: @metallicBlue;\n\t\theight: 38px;\n\t\tpadding: 4px 8px;\n\t\tfont-family: @sofiaFont;\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\n\t\t.__PrivateStripeElement {\n\t\t\ttop: 7px;\n\t\t}\n\t}\n}\n\n.noticeMessage {\n\t@marginTop: -20px; // k-form-field margin-bottom is 20px. Remove the gap between message and k-form-field\n\n\tdisplay: block;\n\tmax-width: 270px;\n\tmargin: 10px auto 0 auto;\n\tfont-size: 12px;\n\tline-height: 16px;\n\tcolor: @grey26;\n\tpadding: 0 10px;\n\tmargin-top: @marginTop;\n\ta {\n\t\tfont-weight: @sofiaFontBold;\n\t\tcolor: @brightNavy;\n\t}\n}\n\n.fieldset .verifyCardButton {\n\tmargin: 20px auto 0 auto;\n\tleft: 182px;\n\twidth: 108px;\n\theight: 36px;\n\tbackground-color: rgba(25, 65, 155, 0.13);\n\tborder-radius: 19px;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: @brightNavy;\n\n\tspan {\n\t\topacity: 1;\n\t}\n}\n\n.fieldset .verifiedResult {\n\tdisplay: inline-flex;\n\tjustify-content: space-between;\n\tvertical-align: bottom;\n\twidth: @inputWidth;\n\tmargin: 5px auto;\n\n\tspan {\n\t\tdisplay: inline-block;\n\t\tline-height: 32px;\n\t\tcolor: @selectedBlue;\n\t\tvertical-align: middle;\n\t}\n\n\tspan:first-child {\n\t\ttext-transform: capitalize;\n\t}\n\n\tbutton.deleteIcon {\n\t\tmargin: 0;\n\t\tvertical-align: bottom;\n\t\tborder-radius: 4px;\n\t\tbackground-color: transparent;\n\t\timg {\n\t\t\twidth: 20px;\n\t\t}\n\t}\n}\n\n.stripeFormErrorMessage {\n\tmargin: 0 auto 20px auto;\n\tfont-size: 12px;\n\tcolor: @sunsetOrange;\n}\n\n@media (min-width: @twoColumnFieldsPageMinWidth) {\n\t.noticeMessage {\n\t\tdisplay: inline-block;\n\t\tmax-width: calc(100% - 120px);\n\t}\n\n\t.fieldset .verifiedResult {\n\t\twidth: 318px;\n\t}\n\n\t.stripeFormErrorMessage {\n\t\tpadding-left: 25px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
